<template>
  <div class="gray-back page-step5">
    <van-form @submit="onSubmit" @failed="onFailed">
      <van-divider>确认订单</van-divider>

      <van-cell-group>
        <van-cell title="报名场次" :value="row._saiqu.name || '—'" input-align="right"/>
        <van-cell
            v-for="(item,index) in row.list"
            :key="index"
            input-align="right"
            :title="item.service_name"
            :value="'¥' + item.price + ' x ' + item.count"
        />
        <van-cell title="费用总计" :value="'¥' + (row.order.total || 0)" input-align="right"/>
      </van-cell-group>

      <div style="height: 1rem"></div>
      <div class="savebtn">
        <van-button
            style="width: 3rem"
            size="normal"
            round
            native-type="button"
            @click="goPre"
        >上一步
        </van-button>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal"
            round
            native-type="submit"
            :disabled="saveLoading"
            :loading="saveLoading"
            loading-text="提交中..."
        >确定提交
        </van-button>
      </div>
    </van-form>

    <van-popup
        v-model="offlinePayQrShow"
        position="bottom"
        round
        closeable
        close-icon-position="top-right"
        :style="{ maxHeight: '88%', paddingBottom: 'env(safe-area-inset-bottom)' }"
    >
      <div class="offline-pay-popup">
        <div class="offline-pay-popup__title">线下付款请扫码</div>
        <div v-for="(pic, idx) in payQrcodeList" :key="idx" class="offline-pay-popup__img-wrap">
          <img class="offline-pay-popup__img" :src="pic.url" alt="付款二维码"/>
        </div>
        <div v-if="payQrcodeList.length === 0" class="offline-pay-popup__empty">暂无收款二维码</div>
        <van-button
            block
            round
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            class="offline-pay-popup__btn"
            @click="goOfflinePayUpload"
        >上传汇款凭证</van-button>
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
.page-step5 {
  min-height: 100vh;
  box-sizing: border-box;
  padding: .2rem 0 1rem 0;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.offline-pay-popup {
  padding: 0.36rem 0.32rem 0.4rem;
  box-sizing: border-box;
}

.offline-pay-popup__title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0.28rem;
  color: #323233;
}

.offline-pay-popup__img-wrap {
  text-align: center;
  margin-bottom: 0.24rem;
}

.offline-pay-popup__img {
  max-width: 72%;
  width: 100%;
  display: inline-block;
  vertical-align: top;
  border-radius: 8px;
}

.offline-pay-popup__empty {
  text-align: center;
  color: #969799;
  font-size: 14px;
  padding: 0.32rem 0;
}

.offline-pay-popup__btn {
  margin-top: 0.16rem;
}
</style>

<script>
import Vue from 'vue';
import { Cell, Form, Divider, CellGroup, Toast, Button, Popup } from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Toast).use(Button).use(Popup);

export default {
  name: 'AbilityApplyStep5',
  components: {},
  data() {
    return {
      saveLoading: false,
      offlinePayQrShow: false,
      row: {
        id: 0,
        _saiqu: {},
        list: [],
        order: {},
      },
    };
  },
  computed: {
    payQrcodeList() {
      const q = this.row._saiqu && this.row._saiqu.pay_qrcode;
      return Array.isArray(q) ? q : [];
    },
  },
  mounted() {
    document.title = '确认订单';
    this.row.id = this.$route.query.id;
    if (this.row.id) {
      this.fetch();
    } else {
      Toast.fail('缺少报名编号');
    }
  },
  methods: {
    goPre() {
      rbLink({
        name: 'AbilityApplyStep3',
        query: { id: this.row.id },
      }, 'replace');
    },
    fetch() {
      const that = this;
      that.$api.post('/api/ability/step5detail', { id: that.row.id }, (res) => {
        that.row = res.data || {};
      }, (res) => {
        Toast.fail(res.msg || '加载失败');
      });
    },
    goOfflinePayUpload() {
      this.offlinePayQrShow = false;
      rbLink({
        name: 'AbilityApplyBeizhu',
        query: { id: this.row.id },
      });
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onSubmit() {
      const that = this;
      that.saveLoading = true;
      that.$api.post('/api/ability/ordersave', {
        id: that.row.id,
      }, () => {
        that.saveLoading = false;
        Toast.success('保存成功');
        that.offlinePayQrShow = true;
      }, (res) => {
        Toast.fail(res.msg || '保存失败');
        that.saveLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// AbilityApplyStep5.vue?1249edaa